import initDeleteTagModal from '~/tags/init_delete_tag_modal';

initDeleteTagModal();
